import React from 'react';
import WidgetWrapper from './WidgetWrapper';

const GrafanaWidget = ({ darkMode = false, onError }) => {
  const textColor = darkMode ? '#f3f4f6' : '#111827';
  const bgSecondary = darkMode ? '#374151' : '#f3f4f6';

  const dashboards = [
    { name: 'NGX-All-Hosts', uid: 'ngx-all-hosts', url: 'https://grafana.nexgenx.org/d/ngx-all-hosts' },
    { name: 'NGX-CEPH', uid: 'ngx-ceph', url: 'https://grafana.nexgenx.org/d/ngx-ceph' },
    { name: 'NGX-Prod', uid: 'ngx-prod', url: 'https://grafana.nexgenx.org/d/ngx-prod' },
    { name: 'NGX-Prod2', uid: 'ngx-prod2', url: 'https://grafana.nexgenx.org/d/ngx-prod2' },
    { name: 'NGX-Prod3', uid: 'ngx-prod3', url: 'https://grafana.nexgenx.org/d/ngx-prod3' },
    { name: 'NGX-Prod4', uid: 'ngx-prod4', url: 'https://grafana.nexgenx.org/d/ngx-prod4' },
    { name: 'NGX-Prod5', uid: 'ngx-prod5', url: 'https://grafana.nexgenx.org/d/ngx-prod5' },
    { name: 'NGX-Prod6', uid: 'ngx-prod6', url: 'https://grafana.nexgenx.org/d/ngx-prod6' }
  ];

  return (
    <WidgetWrapper title="📈 Grafana Dashboards" loading={false} darkMode={darkMode}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
        {dashboards.map(d => (
          <a
            key={d.uid}
            href={d.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '8px 12px',
              background: bgSecondary,
              borderRadius: 6,
              textDecoration: 'none',
              color: textColor,
              fontSize: 12,
              textAlign: 'center'
            }}
          >
            {d.name}
          </a>
        ))}
      </div>
    </WidgetWrapper>
  );
};

// Widget metadata
GrafanaWidget.widgetId = 'grafana';
GrafanaWidget.title = '📈 Grafana Dashboards';
GrafanaWidget.defaultSize = { cols: 6 };
GrafanaWidget.category = 'infrastructure';

export default GrafanaWidget;